import { Injectable } from '@angular/core';

@Injectable()
export class FunctionUtil {	 
    static DelayFunctionExecution(func: () => void, wait: number): Function
	{ 
		let h: number;
		return () => {
			clearTimeout(h);
			h = window.setTimeout(() => func(), wait);
		};
	}
}